
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"87","height":"87","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_156_1505)"}},[_c('path',{attrs:{"d":"M43.402.38a2.538 2.538 0 00-2.532 2.527v14.007a2.537 2.537 0 002.532 2.527 2.536 2.536 0 002.547-2.527V2.907A2.537 2.537 0 0043.402.38zM13.437 10.77a2.537 2.537 0 00-1.794.753 2.537 2.537 0 000 3.592l9.904 9.89a2.537 2.537 0 003.578-3.598l-9.89-9.884a2.537 2.537 0 00-1.798-.753zM32.72 29.974a2.537 2.537 0 00-2.522 3.21l14.25 51.573a2.537 2.537 0 004.627.62l8.388-14.25 11.593 11.589a2.538 2.538 0 003.593 0l10.186-10.187a2.537 2.537 0 000-3.592L71.113 57.214l14.363-8.259a2.536 2.536 0 00-.58-4.642L33.304 30.058c-.191-.05-.388-.079-.585-.084h.001zm3.562 6.189l41.406 11.425-11.966 6.872a2.537 2.537 0 00-.544 3.988l12.287 12.283-6.614 6.595-12.114-12.1a2.538 2.538 0 00-3.988.506l-7.001 11.91-11.466-41.48zM3.047 40.736a2.537 2.537 0 100 5.073h13.986a2.537 2.537 0 000-5.073H3.047z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_156_1505"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5 .375)","d":"M0 0h86.25v86.25H0z"}})])])])
          )
        }
      }
    